module.exports = __webpack_public_path__ + "img/telegram-monochrome.49e0558b.svg";